import React, { ReactNode } from 'react';

import styles from './index.module.scss';
import { Reveal } from 'components/ui/Reveal/Reveal';
import { ChevronDownIcon } from '@razorpay/blade/components';

export interface ExpansionPanelProps {
  panelId: number;
  isOpen: boolean;
  onHeaderClick: (panelId: number) => void;
  header: JSX.Element | string;
  className?: string;
  children: ReactNode;
  scrollable?: boolean;
  disabled?: boolean;
  childrenClassName?: string;
}

const ExpansionPanel = ({
  panelId,
  isOpen,
  onHeaderClick,
  header,
  className,
  children,
  scrollable,
  disabled,
  childrenClassName,
}: ExpansionPanelProps) => {
  const onInteract = () => {
    !disabled && onHeaderClick(panelId);
  };

  return (
    <div className={`${styles['expansion-panel']} ${className}`}>
      <div className="flex justify-between items-center cursor-pointer" onClick={onInteract}>
        <h3 className={styles['expansion-panel-header']}>{header}</h3>
        <span
          className={`inline-block transition duration-300 mr-3 ${
            isOpen ? 'transform rotate-180 ' : ''
          }`}>
          <ChevronDownIcon color="surface.icon.gray.muted" />
        </span>
      </div>
      <Reveal isOpen={isOpen}>
        <div
          className={`${styles['expansion-panel-content']} transition duration-300 ${
            scrollable ? 'overflow-y-auto' : ''
          } 
              ${childrenClassName ? childrenClassName : ''}`}>
          {children}
        </div>
      </Reveal>
    </div>
  );
};

export default ExpansionPanel;
